module.exports = __webpack_public_path__ + "static/media/1POLICY25.8d2d1d54.jpg";